import { render, staticRenderFns } from "./VoteFor.vue?vue&type=template&id=3e821773&scoped=true&"
import script from "./VoteFor.vue?vue&type=script&lang=js&"
export * from "./VoteFor.vue?vue&type=script&lang=js&"
import style0 from "./VoteFor.vue?vue&type=style&index=0&id=3e821773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e821773",
  null
  
)

export default component.exports